import React from "react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { 
    LayoutDashboard, CheckCircle2, ShieldCheck, Zap, 
    Smartphone, BarChart3, ArrowRight, UserPlus 
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link, useNavigate } from "react-router-dom";

export const POSPage = () => {
    const navigate = useNavigate();
    const isSeller = !!localStorage.getItem("seller_token");

    return (
        <div className="min-h-screen bg-white flex flex-col">
            <Header />
            
            {/* Hero Section */}
            <section className="relative pt-20 pb-32 overflow-hidden">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full -z-10 bg-gradient-to-b from-[#FF9900]/5 to-transparent"></div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#FF9900]/10 text-[#FF9900] font-black text-[10px] uppercase tracking-widest mb-8 animate-bounce">
                        <Zap className="w-4 h-4" /> Nouvo: BVG LINK POS
                    </div>
                    <h1 className="text-5xl md:text-7xl font-black text-[#232F3E] tracking-tighter italic mb-6 leading-none">
                        Vann pi rapid. <br />
                        <span className="text-[#FF9900]">Jere pi byen.</span>
                    </h1>
                    <p className="text-gray-500 text-lg md:text-xl font-medium max-w-2xl mx-auto mb-12">
                        BVG LINK POS se premye sistèm multivendor an Ayiti ki pèmèt ou vann nan magazen ak sou entènèt nan yon sèl plas.
                    </p>
                    
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                        {isSeller ? (
                            <Button 
                                onClick={() => navigate("/seller/dashboard")}
                                className="h-16 px-10 bg-[#232F3E] hover:bg-black text-white rounded-2xl font-black text-xs uppercase tracking-widest shadow-2xl transition-all hover:scale-105 flex items-center gap-3"
                            >
                                <LayoutDashboard className="w-6 h-6 text-[#FF9900]" /> LANSE POS MWEN
                            </Button>
                        ) : (
                            <>
                                <Button 
                                    onClick={() => navigate("/seller/register")}
                                    className="h-16 px-10 bg-[#FF9900] hover:bg-[#E88B00] text-white rounded-2xl font-black text-xs uppercase tracking-widest shadow-2xl transition-all hover:scale-105 flex items-center gap-3"
                                >
                                    <UserPlus className="w-6 h-6" /> KREYE KONT MACHANN
                                </Button>
                                <Button 
                                    onClick={() => navigate("/seller/login")}
                                    variant="outline"
                                    className="h-16 px-10 border-2 border-gray-100 rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-gray-50 transition-all"
                                >
                                    KONEKTE
                                </Button>
                            </>
                        )}
                    </div>
                </div>
            </section>

            {/* Features Area */}
            <section className="py-24 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                        <div className="p-10 bg-white rounded-[40px] shadow-xl border border-gray-100 hover:scale-105 transition-transform duration-500">
                            <div className="w-16 h-16 bg-[#FF9900]/10 rounded-2xl flex items-center justify-center text-[#FF9900] mb-8">
                                <Smartphone className="w-8 h-8" />
                            </div>
                            <h3 className="text-2xl font-black text-gray-900 mb-4 tracking-tighter italic">Multi-vendor Ready</h3>
                            <p className="text-gray-500 font-medium">Jere pwòp pwodwi ou, pwòp pri ou, e pwòp panye ou san melanje ak lòt moun.</p>
                        </div>
                        <div className="p-10 bg-[#232F3E] rounded-[40px] shadow-xl text-white hover:scale-105 transition-transform duration-500">
                            <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center text-[#FF9900] mb-8">
                                <Zap className="w-8 h-8" />
                            </div>
                            <h3 className="text-2xl font-black mb-4 tracking-tighter italic">Peman MonCash</h3>
                            <p className="text-gray-300 font-medium">Jenerale lyen peman oswa QR Code rapid rapid pou kliyan an peye nèt ale.</p>
                        </div>
                        <div className="p-10 bg-white rounded-[40px] shadow-xl border border-gray-100 hover:scale-105 transition-transform duration-500">
                            <div className="w-16 h-16 bg-blue-500/10 rounded-2xl flex items-center justify-center text-blue-500 mb-8">
                                <BarChart3 className="w-8 h-8" />
                            </div>
                            <h3 className="text-2xl font-black text-gray-900 mb-4 tracking-tighter italic">Repporting Real-time</h3>
                            <p className="text-gray-500 font-medium">Wè tout vant ou fè nan jounen an, kach ou resevwa, epi kontwole balans ou mèm kote a.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why BVG LINK POS? */}
            <section className="py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col lg:flex-row items-center gap-20">
                        <div className="lg:w-1/2 space-y-8">
                            <div className="inline-flex px-4 py-2 bg-blue-50 rounded-lg text-blue-600 font-black text-[10px] uppercase tracking-widest">POUKISA NOU?</div>
                            <h2 className="text-4xl md:text-5xl font-black text-gray-900 tracking-tighter italic leading-none">Pwan kontwòl <br /><span className="text-blue-600">biznis ou kounye a.</span></h2>
                            
                            <div className="space-y-6">
                                {[
                                    "Venn sou plas oswa voye kòmand bay kliyan.",
                                    "Sistèm livrezon ak chofè entegre otomatikman.",
                                    "Jere envantè ou soti nan telefòn oswa PC.",
                                    "Transpò ak sekirite garanti."
                                ].map((item, i) => (
                                    <div key={i} className="flex items-center gap-4">
                                        <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center text-green-600 shadow-sm">
                                            <CheckCircle2 className="w-4 h-4" />
                                        </div>
                                        <p className="text-gray-700 font-bold">{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="lg:w-1/2">
                            <div className="relative">
                                <div className="absolute -inset-10 bg-[#FF9900]/20 rounded-full blur-3xl opacity-30 -z-10 animate-pulse"></div>
                                <div className="p-8 bg-[#232F3E] rounded-[50px] shadow-3xl text-[#FF9900]">
                                    <LayoutDashboard className="w-full h-auto p-12" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};
